"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MigrateTicketsRequestStruct = void 0;
const superstruct_1 = require("superstruct");
exports.MigrateTicketsRequestStruct = (0, superstruct_1.type)({
    placeId: (0, superstruct_1.string)(),
    organisationId: (0, superstruct_1.string)(),
    startFrom: (0, superstruct_1.string)(),
});
//# sourceMappingURL=MigrateTicketsRequest.js.map